import { Pipe, PipeTransform } from '@angular/core';
import { planTypeDropdown } from '../consts/plan-type-dropdown';

@Pipe({
  name: 'planTypeDescription',
  standalone: true,
})
export class PlanTypeDescriptionPipe implements PipeTransform {
  transform(value: string[] | number, abbreviated = false): string {
    if (typeof value === 'number') {
      return this.getDescriptionById(value, abbreviated);
    }

    if (Array.isArray(value)) {
      const descriptions = value
        .map((item) => this.getDescriptionById(+item.trim(), abbreviated))
        .filter((desc, index, self) => self.indexOf(desc) === index);

      return descriptions.join(', ');
    }

    return '--';
  }

  private getDescriptionById(id: number, abbreviated = false): string {
    if (id === null || id === undefined || id === 0) {
      return '--';
    }

    const ref = planTypeDropdown().find((item) => item.id === id);
    if (!ref) return '--';
    return abbreviated && ref.short ? ref.short : ref.description;
  }
}
